/** Joins truthy class names (mirrors the design system's `cx`). */
export function cx(...parts: Array<string | false | null | undefined | 0>): string {
  return parts.filter(Boolean).join(' ');
}
